import { render, staticRenderFns } from "./slot2.vue?vue&type=template&id=df478b0a&scoped=true&"
import script from "./slot2.vue?vue&type=script&lang=js&"
export * from "./slot2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df478b0a",
  null
  
)

export default component.exports